import { get } from "lodash"

export function getImgFluid(source) {
  return get(source, "localFile.childImageSharp.fluid", null)
}
